import { SIZES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledTableTeamsCol = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: ${SIZES.medium};
  &.name {
    & .avatar {
      margin-right: 1rem;
    }
    & > svg {
      margin-left: 1rem;
    }
  }
  &.options {
    display: flex;
    justify-content: flex-end;
    & svg {
      cursor: pointer;
      margin-left: 1rem;
      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export const StyledTeams = styled.div`
  & .MuiTable-root {
    width: 100%;
  }
`;
